"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMatrixDataTypeDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var getMatrixDataTypeDependencies = exports.getMatrixDataTypeDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createGetMatrixDataType: _factoriesAny.createGetMatrixDataType
};